module.exports = __webpack_public_path__ + "img/PM_A02_back_cross_diagonal_horizontal_en.e474b1d0.png";